import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { setAppTitle } from '../../../store/commonSlice'
import { routes } from '../../../utils/routes'
import { Link } from 'react-router-dom'

import { useSelector } from 'react-redux'

function TruckEdit(props: any) {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(setAppTitle('Truck List'))
  }, [])

  const data = props?.selectedTruck
  console.log(data)

  return (
    <>
      <div id='editTruck'>
        <div className='offcanvas-header popup-canvas-header'>
          <div className='offcanvas-header-edit'>
            {/* <h5 id="offcanvasRightLabel" className="mt-0">Edit</h5>
					<p>Please fill below details and update truck list</p> */}
          </div>
          <a
            href='javascript:void(0);'
            className='clear-truck-list'
            data-bs-dismiss='offcanvas'
            aria-label='Close'
          >
            <i className='fas fa-xmark'></i>
          </a>
        </div>
        <div className='offcanvas-body popup-offcanvas-body'>
          <div className='container p-0'>
            <div className='row'>
              <form>
                <div className='col-md-12 form-checklist-info'>
                  <h5 className='mt-0'>Truck Details</h5>
                  <div className='row mt-2'>
                    <div className='col-md-6'>
                      <div className='edit-trucklist'>
                        <div className='form-checklist mt-2'>
                          <label htmlFor='truckname' className='form-label'>
                            Truck Name
                          </label>
                          <input
                            type='text'
                            className='form-control'
                            id='truckname'
                            aria-describedby='truckname'
                            placeholder='Truck Name'
                            value=''
                          />
                        </div>
                      </div>
                    </div>
                    <div className='col-md-6'>
                      <div className='edit-trucklist'>
                        <div className='form-checklist mt-2'>
                          <label htmlFor='truckname' className='form-label'>
                            Truck Number
                          </label>
                          <input
                            type='text'
                            className='form-control'
                            id='truckname'
                            aria-describedby='truckname'
                            placeholder='Truck Number'
                            value={data.truck_number}
                          />
                        </div>
                      </div>
                    </div>
                    <div className='col-md-6'>
                      <div className='edit-trucklist'>
                        <div className='form-checklist mt-2'>
                          <label htmlFor='drivername' className='form-label'>
                            Model Year
                          </label>
                          <input
                            type='text'
                            className='form-control'
                            id='drivername'
                            aria-describedby='drivername'
                            placeholder='Model Year'
                            value={data.year}
                          />
                        </div>
                      </div>
                    </div>
                    <div className='col-md-6'>
                      <div className='edit-trucklist'>
                        <div className='form-checklist mt-2'>
                          <label htmlFor='Company' className='form-label'>
                            Company
                          </label>
                          <input
                            type='text'
                            className='form-control'
                            id='Company'
                            aria-describedby='Company'
                            placeholder='Company Name'
                            value=''
                          />
                        </div>
                      </div>
                    </div>
                    <div className='col-md-6'>
                      <div className='edit-trucklist'>
                        <div className='form-checklist mt-2'>
                          <label htmlFor='inspectorname' className='form-label'>
                            Inspector Name
                          </label>
                          <input
                            type='text'
                            className='form-control'
                            id='inspectorname'
                            aria-describedby='inspectorname'
                            placeholder='Inspector Name'
                            value=''
                          />
                        </div>
                      </div>
                    </div>
                    <div className='col-md-6'>
                      <div className='edit-trucklist'>
                        <div className='form-checklist mt-2'>
                          <label htmlFor='Company' className='form-label'>
                            Inspection Date
                          </label>
                          <div className='truck-datepicker'>
                            <input
                              data-provide='datepicker'
                              className='form-control'
                              value='07-15-2024'
                            />
                            <i className='fa-solid fa-calendar-days'></i>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='col-md-6'>
                      <div className='edit-trucklist'>
                        <div className='form-checklist mt-2'>
                          <label htmlFor='Company' className='form-label'>
                            Status
                          </label>
                          <select
                            id='edittruck'
                            className='js-states form-control edittruck'
                          >
                            <option>Active</option>
                            <option>Minor</option>
                            <option>Blacklist</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className='col-md-12'>
                      <div className='edit-trucklist'>
                        <div className='form-checklist mt-2'>
                          <label htmlFor='Company' className='form-label'>
                            Truck Image
                          </label>
                          <div className='truck-image'>
                            <input
                              type='file'
                              id='input-file-now'
                              className='dropify'
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='col-md-12 form-btn mt-4 pb-4'>
                      <button type='submit' className='btn create-btn btn-hvr'>
                        Save
                      </button>
                      <button type='submit' className='btn cancel-btn'>
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
export default TruckEdit
